export var OrgID;

(function (OrgID) {
  OrgID["Cofit"] = "3";
  OrgID["Genesis"] = "21";
  OrgID["Lumez"] = "26";
  OrgID["Cymbal"] = "29";
  OrgID["Cymbalxinlin"] = "33";
  OrgID["GenesisKH"] = "34";
  OrgID["LumezGenesis"] = "38";
  OrgID["GenesisHC"] = "39";
  OrgID["Tianyi"] = "48";
  OrgID["Testing"] = "27";
  OrgID["YouCofitHQ"] = "49";
  OrgID["FCLab"] = "35";
  OrgID["AuFait"] = "40";
})(OrgID || (OrgID = {}));

export var BranchID;

(function (BranchID) {
  BranchID[BranchID["Cofit"] = 157] = "Cofit";
  BranchID[BranchID["Genesis"] = 153] = "Genesis";
  BranchID[BranchID["Lumez"] = 155] = "Lumez";
  BranchID[BranchID["Cymbal"] = 158] = "Cymbal";
  BranchID[BranchID["Cymbalxinlin"] = 160] = "Cymbalxinlin";
  BranchID[BranchID["GenesisKH"] = 161] = "GenesisKH";
  BranchID[BranchID["LumezGenesis"] = 164] = "LumezGenesis";
  BranchID[BranchID["GenesisHC"] = 165] = "GenesisHC";
  BranchID[BranchID["Tianyi"] = 6] = "Tianyi";
  BranchID[BranchID["Testing"] = 153] = "Testing";
  BranchID[BranchID["YouCofitHQ"] = 7] = "YouCofitHQ";
  BranchID[BranchID["FCLab"] = 162] = "FCLab";
  BranchID[BranchID["AuFait"] = 168] = "AuFait";
})(BranchID || (BranchID = {}));

export var Module;

(function (Module) {
  Module["clinic"] = "clinic";
  Module["consult"] = "consult";
})(Module || (Module = {}));

export var ORG_TYPE;

(function (ORG_TYPE) {
  ORG_TYPE["CLINIC"] = "CLINIC";
  ORG_TYPE["CONSULT"] = "CONSULT";
})(ORG_TYPE || (ORG_TYPE = {}));